const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Hai',
    'Ref: Page content body':
      'Setibanya dan berangkat, pastikan untuk mengingat untuk memindai bus kode QR Anda',
  },
};
export default labels;
